<template>
    <div>
        <div class="action-header">
            <el-input class="input" clearable placeholder="搜索您的商户" v-model="key">
                <i
                    @click="handleSearch"
                    class="el-input__icon el-icon-search btn-search"
                    slot="suffix"
                />
            </el-input>
        </div>
        <Table />
        <Pagination />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Table from './table';
import Pagination from './pagination';

const { mapActions } = createNamespacedHelpers('install');

export default {
    components: { Table, Pagination },
    data() {
        return {
            key: '',
        };
    },
    methods: {
        ...mapActions(['searchSites', 'changeSearch', 'clearState']),
        handleSearch() {
            this.changeSearch({ key: this.key, page: 1 });
        },
    },
    mounted() {
        this.searchSites();
    },
    beforeDestroy() {
        this.clearState();
    },
};
</script>

<style lang="less" scoped>
.action-header {
    margin-bottom: 20px;
    overflow: hidden;
    .input {
        float: right;
        width: 250px;
    }
}
.btn-search {
    width: 30px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
        color: #409eff;
    }
}
</style>
